import React from "react";
import "./customMultipleSwitch.css";
import PropTypes from "prop-types";

/**
 * Custom switch component
 * Styled
 * General component
 */
const CustomMultipleSwitch = ({
  data,
  selectedValue: propsSelectedValue,
  defaultValue,
  style,
  changeValue,
  changeValueExtraParameters
}) => {
  const selectedValue = propsSelectedValue === undefined ? defaultValue : propsSelectedValue;

  const onChange = (event, value) => {
    event.preventDefault();
    event.stopPropagation();

    const extra = changeValueExtraParameters ?? null;
    changeValue(value, extra);
  };

  return (
    <div className={"custom-option-single-select"} style={style}>
      {data.map(option => (
        <div
          key={option.id || option.value}
          id={option.id}
          name={option.name}
          className={
            selectedValue === option.value
              ? option.color
                ? "option-item " + option.color
                : "option-item default"
              : "option-item unselect"
          }
          onClick={event => onChange(event, option.value)}
        >
          <span style={{ fontSize: '10px' }}>{option.title}</span>
        </div>
      ))}
    </div>
  );
};

CustomMultipleSwitch.propTypes = {
  hideOffButton: PropTypes.bool,
  data: PropTypes.array.isRequired,
  selectedValue: PropTypes.string,
  defaultValue: PropTypes.string,
  style: PropTypes.object,
  changeValue: PropTypes.func.isRequired,
  changeValueExtraParameters: PropTypes.any
};

export default CustomMultipleSwitch;
